import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "flow-right",
  "use": "flow-right-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"flow-right\"><title>Flow</title><g stroke-width=\"3.2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.2 15.588L16.988 8.8 10.2 2.012M2.2 15.588L8.988 8.8 2.2 2.012\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/flow-right.svg
// module id = 520
// module chunks = 0